import axios from "axios";
import { logoutUser } from "../apps/authSlice";

const authCheckMiddleware = (store) => (next) => async (action) => {
  if (
    action.error &&
    (action.error.message.includes("500") ||
      action.error.message.includes("401") ||
      action.error.message.includes("Network Error"))
  ) {
    window.location.reload();
    store.dispatch(logoutUser());
    return;
  }

  // auth ve layout ile ilgili action'lar için authCheck yapmadan devam et
  if (
    action.type.startsWith("auth/") ||
    action.type.startsWith("LayoutSlice/")
  ) {
    return next(action);
  }

  if (action.type.endsWith("/fulfilled")) {
    try {
      const user = localStorage.getItem("authUser");

      if (user) {
        const data = JSON.parse(user);

        const authResult = await axios.get(
          `https://api.globalyolyardim.com/Account/AuthCheck`,
          {
            headers: {
              Authorization: `Bearer ${data.token}`,
            },
          }
        );

        const hasChangesRole =
          data.data.Role !== authResult.data.Value.Role ||
          authResult.data.Value.Role === "Customer";
        const hasChangesUser =
          data.data.NameSurname !== authResult.data.Value.NameSurname;

        if (hasChangesRole || authResult.status == 400) {
          store.dispatch(logoutUser());
          window.location.reload();
          return;
        } else if (hasChangesUser) {
          data.data.NameSurname = authResult.data.Value.NameSurname;

          localStorage.setItem("authUser", JSON.stringify(data));
          return next(action);
        }
      } else {
        store.dispatch(logoutUser());
        window.location.reload();
        throw new Error("Kullanıcı bulunamadı!");
      }
    } catch (error) {
      window.location.reload();
      store.dispatch(logoutUser());
      return;
    }
  }

  return next(action);
};

export default authCheckMiddleware;
